// extracted by mini-css-extract-plugin
export default {"spinnerBack":"Spinner_spinnerBack__S0ziB","cssloadWrap":"Spinner_cssloadWrap__WWZGP","cssloadCircle":"Spinner_cssloadCircle__vajCh","cssloadSpin":"Spinner_cssloadSpin__Dsx9Y"};